import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { doRequest, userID } from "../../../../utils/helper";
import GoBack from "../img/go-back-icn.svg";
import saveIcon from "../img/save-icn.svg";
import resetIcon from "../img/reset-button-icn.svg";
import SizeInput from "./SizeInput";
import OwnSizeListComponant from "./OwnSizeListComponant";
import { showToast } from "../../../../redux/slices/ToastSlice";
import { Link } from "react-router-dom";

export default function SizeSelectorUiNew() {
  const userId = userID();
  const dispatch = useDispatch();
  const error = useSelector((state) => state.sizeDimension.error);
  const [profileList, setProfileList] = useState([]);
  const [selectedListData, setSelectedListData] = useState({});
  const [selectedListDataForReset, setSelectedListDataForReset] = useState({});
  const [changedSizes, setChangedSizes] = useState([]);
  const [changedSizesUp, setChangedSizesUp] = useState([]);
  const [defaultSizeData, setDefaultSizeData] = useState({});
  const [first, setFirst] = useState(true)
  const [loading, setLoading] = useState(false);
  const sizes = useSelector((state) => state.sizeDimension.sizes);
  const toKebabCase = (str) => {
    return str.toLowerCase().trim().replace(/\s+/g, "-"); // replace spaces with -
  };

  const [activeRowIndex, setActiveRowIndex] = useState(null);

  const getProfileList = async (id, onchange) => {
    
    // PRIORITY ORDER:
    // 1. If specific ID requested (e.g. after save) → use it
    // 2. If any profile has is_active: true → use that
    // 3. If none active → use is_default: true
    // 4. Last resort → first in list

    
    try {
      setLoading(true);
      const response = await doRequest({}, "GET", "sizesheet/profiles");
      console.log("response", response);

      const defaultProfile = response.find(p => p.is_default);
      if (defaultProfile) {
        const defaultSizes = await doRequest(
          "",
          "GET",
          `sizesheet/sizes?profileId=${defaultProfile.id}`
        );
        setDefaultSizeData(defaultSizes);
      }


      setProfileList(response);
      setFirst(false);
      setLoading(false);
  
      let profileToLoad = null;
  
      if (id) {
        profileToLoad = response.find(p => p.id === id);
      }
  
      if (!profileToLoad) {
        profileToLoad = response.find(p => p.is_active === true);
      }
  
      if (!profileToLoad) {
        profileToLoad = response.find(p => p.is_default === true);
      }
  
      if (!profileToLoad && response.length > 0) {
        profileToLoad = response[0];
      }
  
      if (profileToLoad) {
        getSelectedListSizeData(
          profileToLoad.id,
          "existed",
          "",
          onchange
        );
      }
  
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const getSelectedListSizeData = async (id, existed, loader, onChange,nname) => {
    if (!existed) {
      console.log("data for new 0", defaultSizeData);

      let data = JSON.parse(JSON.stringify(defaultSizeData)); // deep clone
      data["profile"]["id"] = id;
      data["profile"]["profile_name"] = nname;
      data["profile"]["is_default"] = false;
      data["isNew"] = true;
      setSelectedListData(data);
      setSelectedListDataForReset(data);
      console.log("data for new", defaultSizeData);
      return;
    }
    try {
      if (loader) {
        setLoading(true);
      }
      const response = await doRequest(
        "",
        "GET",
        `sizesheet/sizes?profileId=${id}`
      );
      
      if (onChange) {
        const response2 = await doRequest(
          "",
          "GET",
          `sizesheet/set-active?profileId=${id}`
        );
      }
      setLoading(false);

      setSelectedListData(response);
      setSelectedListDataForReset(response);
      if (response?.profile?.is_default) {
        console.log(
          "response?.profile?.is_default",
          response?.profile?.is_default
        );
        setDefaultSizeData(response);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const createNewList = async (name) => {
    console.log('new list name',name)
    let obj = {
      id: name + Math.floor(Date.now() / 1000),
      profile_name: name,
      is_default: false,
      isNew: true,
    };
    let arr = profileList;
    arr.push(obj);
    setProfileList(arr);
    let data = JSON.parse(JSON.stringify(defaultSizeData));
    data["profile"]["profile_name"] = name;
    data["profile"]["id"] = name + Math.floor(Date.now() / 1000);
    data["profile"]["is_default"] = false;
    data["isNew"] = true;
    console.log("data for new 2", defaultSizeData);

    setSelectedListData(data);
    setSelectedListDataForReset(data);
  };

  const renameList = async (id, newname, isNew) => {
    console.log("id", id, "newname", newname, "isNew", isNew);
    if (isNew) {
      let arr = profileList.map((item) =>
        item.id === id ? { ...item, profile_name: newname } : item
      );
      setProfileList(arr);
      const updatedData = {
        ...selectedListData,
        profile: {
          ...selectedListData.profile,
          profile_name: newname,
        },
      };
      const updatedData2 = {
        ...selectedListData,
        profile: {
          ...selectedListDataForReset.profile,
          profile_name: newname,
        },
      };
      setSelectedListData(updatedData);
      setSelectedListDataForReset(updatedData2);
    } else {
      let data = {
        profileId: id,
        profile_name: newname,
      };
      const response = await doRequest(
        data,
        "POST",
        "sizesheet/update-profile-name"
      );
      dispatch(showToast({ message: "List renamed successfully" }));
      getProfileList(id);
    }
  };

  const handleSizeChange = (catId, labId, width, height, elementId) => {
    const updated = Object.fromEntries(
      Object.entries(
        selectedListData?.categories.find((i) => i.category_id == catId)?.sizes
      ).map(([key, value]) =>
        value.label_id === labId
          ? [key, { ...value, width: width, height: height }]
          : [key, value]
      )
    );
    console.log("updated", updated);
    setSelectedListData((prev) => {
      const updatedCategories = prev.categories.map((category) =>
        category.category_id === catId
          ? { ...category, sizes: Object.values(updated) }
          : category
      );
      return { ...prev, categories: updatedCategories };
    });
    let obj = {
      category_id: catId,
      label_id: labId,
      width: +width,
      height: +height,
    };

    setChangedSizes((prev) => {
      // Check if the same category+label already exists
      const existingIndex = prev.findIndex(
        (item) =>
          item.category_id === obj.category_id && item.label_id === obj.label_id
      );

      if (existingIndex !== -1) {
        // Replace existing object with new values
        return prev.map((item, index) =>
          index === existingIndex ? obj : item
        );
      } else {
        // Add new if not exists
        return [...prev, obj];
      }
    });

    let obj2 = {
      id: elementId,
      width: +width,
      height: +height,
    };

    setChangedSizesUp((prev) => {
      // Check if the same category+label already exists
      const existingIndex = prev.findIndex((item) => item.id === obj2.id);

      if (existingIndex !== -1) {
        // Replace existing object with new values
        return prev.map((item, index) =>
          index === existingIndex ? obj2 : item
        );
      } else {
        // Add new if not exists
        return [...prev, obj2];
      }
    });
  };

  const createAndAddData = async () => {
    let data = {};
    try {
      data = {
        profileName: selectedListData?.profile.profile_name,
        baseProfile: defaultSizeData?.profile.id,
        updates: changedSizes,
      };
      const response = await doRequest(data, "POST", "sizesheet/clone");
      getProfileList(response.profile.id,'onchange');
    } catch (error) {}
  };
  console.log(
    "changedSizesUp is : ",
    changedSizesUp,
    "changedSizes",
    changedSizes
  );
  const updateListData = async () => {
    let data = {};
    try {
      data = {
        updates: changedSizesUp,
      };
      const response = await doRequest(data, "POST", "sizesheet/size");
      getProfileList(selectedListData.profile.id);
    } catch (error) {}
  };

  // const handleResetSizes = (catId) => {
  //   setSelectedListData((prev) => {
  //     return {
  //       ...prev,
  //       categories: prev.categories.map((cat) =>
  //         cat.category_id === catId
  //           ? {
  //               ...cat,
  //               sizes: {
  //                 ...selectedListDataForReset.categories.find(
  //                   (c) => c.category_id === catId
  //                 ).sizes,
  //               },
  //             }
  //           : cat
  //       ),
  //     };
  //   });
  // };


  const handleResetSizes = (catId) => {
    setSelectedListData((prev) => {
      const defaultCat = defaultSizeData.categories.find(c => c.category_id === catId);
      if (!defaultCat) return prev;

      const currentCat = prev.categories.find(c => c.category_id === catId);
      if (!currentCat) return prev;

      const updatedSizes = Object.fromEntries(
        Object.entries(currentCat.sizes).map(([key, value]) => {
          const defaultSize = Object.values(defaultCat.sizes).find(
            (d) => d.label_id === value.label_id
          );
          if (defaultSize) {
            return [key, { ...value, width: defaultSize.width, height: defaultSize.height }];
          }
          return [key, value];
        })
      );

      const updatedCategories = prev.categories.map((cat) =>
        cat.category_id === catId
          ? { ...cat, sizes: updatedSizes }
          : cat
      );

      return { ...prev, categories: updatedCategories };
    });

    setChangedSizesUp((prev = []) => {
      const defaultCat = defaultSizeData.categories.find(c => c.category_id === catId);
      if (!defaultCat) return prev;

      const currentCat = selectedListData.categories.find(c => c.category_id === catId);
      if (!currentCat) return prev;

      const resetUpdates = Object.values(currentCat.sizes).map((s) => {
        const defaultSize = Object.values(defaultCat.sizes).find(
          (d) => d.label_id === s.label_id
        );
        if (defaultSize) {
          return {
            id: s.id,
            width: +defaultSize.width,
            height: +defaultSize.height,
          };
        }
        return null;
      }).filter(Boolean);

      const ids = new Set(resetUpdates.map((u) => u.id));
      const filtered = prev.filter((p) => !ids.has(p.id));

      return [...filtered, ...resetUpdates];
    });
  };

  
  const deleteList = async (id) => {
    const response = await doRequest(
      "",
      "GET",
      `sizesheet/delete?profileId=${id}`
    );
    dispatch(showToast({ message: "List deleted successfully" }));
    getProfileList();
  };
  console.log("defaultSizeData", defaultSizeData);

  useEffect(() => {
    getProfileList();
  }, []);

  console.log(selectedListData, "sizes")

  
  return (
    <>
      <main className="artboard--main variation-main">
        <div className="artboard--main__header">
          <div className="artboard--main__header--left--back">
            <Link to="/variation">
              <img src={GoBack} alt="Go Back" />
            </Link>
          </div>
          <div className="artboard--main__header--right">
            {selectedListData?.profile?.is_default ? (
              ""
            ) : selectedListData.isNew ? (
              <button
                className="save-changes-btn"
                onClick={createAndAddData}
                disabled={loading}
              >
                <img src={saveIcon} alt="Save" />
                Create & Save Changes
              </button>
            ) : (
              <button
                className="save-changes-btn"
                onClick={updateListData}
                disabled={loading}
              >
                <img src={saveIcon} alt="Save" />
                Update Changes
              </button>
            )}
          </div>
        </div>

        <section className="artboard--main__sizes--container newSizes">
          <div className="artboard--main__sizes--item" id="size-sizes">
            <h2>Teeshirt Sizes</h2>
            <div className="artboard--main__sizes--item--box--head">
              <div className="artboard--main__sizes--item--box--head--list">
                <div className="data-size-size">Size</div>
              </div>
            </div>
            <div className="artboard--main__sizes--item--box--data">
              {sizes.map((size, index) => (
                <div
                  key={size.id || index}
                  className="artboard--main__sizes--item--box--data--list"
                >
                  <div
                    className={`data-size-size ${activeRowIndex === index ? "selected" : ""}`}
                    onClick={() => setActiveRowIndex(index)}
                  >
                    <div className="data-size-blank">{size.label}</div>
                    <div className="data-size-age">{size.age}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {selectedListData &&
            selectedListData.categories &&
            selectedListData.categories.length > 0 &&
            selectedListData.categories.map((item, index) => {
              console.log("Object.keys(item.sizes)", Object.keys(item.sizes));
              if (
                Object.keys(item.sizes) &&
                Object.keys(item.sizes).length > 0
              ) {
                return (
                  <div
                    className="artboard--main__sizes--item"
                    id={toKebabCase(item?.category_name)}
                    key={index}
                  >
                    {index === 0 && (
                      <OwnSizeListComponant
                        setSelectedListData={setSelectedListData}
                        selectedListData={selectedListData}
                        sizeList={profileList}
                        createNewList={createNewList}
                        getSelectedListSizeData={getSelectedListSizeData}
                        changedSizes={changedSizes}
                        renameList={renameList}
                        deleteList={deleteList}
                      />
                    )}
                    <h2>
                      {item?.category_name}

                      {selectedListData?.profile?.is_default ? null : (
                      <button
                        className="resetSizes"
                        onClick={() => handleResetSizes(item?.category_id)}
                      >
                        <img src={resetIcon} alt="Reset Button Icon" /> Reset
                      </button>
                    )}

                    </h2>
                    <div className="artboard--main__sizes--item--box--head">
                      <div className="artboard--main__sizes--item--box--head--list">
                        <div className="data-size-width">
                          Width <span>(in)</span>
                        </div>
                        <div className="data-size-height">
                          Height <span>(in)</span>
                        </div>
                      </div>
                    </div>
                    {console.log("selectedListData", selectedListData)}
                    <div className="artboard--main__sizes--item--box--data">
                    {Object.entries(item.sizes).map(([key, value], rowIndex) => {
                        return (
                          <div
                            key={value.id || key}
                            className={`artboard--main__sizes--item--box--data--list ${
                              activeRowIndex === rowIndex ? "active-row" : ""
                            }`}
                          >
                            <div className="data-size-width">
                              <SizeInput
                                value={value.width}
                                rowIndex={rowIndex}
                                setActiveRowIndex={setActiveRowIndex}
                                onChange={(e) => {
                                  if (selectedListData?.profile?.is_default) {
                                    createNewList("Custom Size Chart");
                                  } else {
                                    handleSizeChange(
                                      item?.category_id,
                                      value.label_id,
                                      e,
                                      value.height,
                                      value.id
                                    );
                                  }
                                }}
                              />
                            </div>
                            <div className="data-size-height">
                            <SizeInput
                                value={value.height}
                                rowIndex={rowIndex}
                                setActiveRowIndex={setActiveRowIndex}
                                onChange={(e) => {
                                  if (selectedListData?.profile?.is_default) {
                                    createNewList("Custom Size Chart");
                                  } else {
                                    handleSizeChange(
                                      item?.category_id,
                                      value.label_id,
                                      value.width,
                                      e,
                                      value.id
                                    );
                                  }
                                }}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              } else {
                return null;
              }
            })}
        </section>
      </main>
    </>
  );
}